/* eslint-disable camelcase */
import { useHistory, useParams } from 'react-router-dom';
import useHref from './useHref';
import { LocationDescriptor } from 'history';
import { getQueryParam } from '~/utils/helpers';

const useWebHistory = () => {
    const history = useHistory();
    const { app } = useHref();
    const { application_id, user_id, case_id }: any = useParams() || {};
    const email = getQueryParam('email');

    const goBack = () => {
        history.goBack();
    };

    const onGetPath = (path: string) => {
        return path;
    };

    const push = (path: string | LocationDescriptor<any>, state?: any, hasNoCaseId?: boolean) => {
        const initialPath =
            application_id && user_id
                ? `/${application_id}/${user_id}${case_id && !hasNoCaseId ? `/${case_id}` : ''}`
                : '';

        let newPath = onGetPath(typeof path === 'string' ? path : path.pathname!);

        if (typeof path === 'string') {
            let formattedPath = `${initialPath}${newPath}`;

            if (email) {
                if (formattedPath.includes('?')) {
                    formattedPath = `${formattedPath}&email=${email}`;
                } else {
                    formattedPath = `${formattedPath}?email=${email}`;
                }
            }

            history.push(formattedPath, state);

            return;
        }

        newPath = onGetPath(`${path.pathname}${path?.search ? `?${path?.search}` : ''}`!);

        let formattedPath = `${initialPath}${newPath}`;

        if (email) {
            if (formattedPath.includes('?')) {
                formattedPath = `${formattedPath}&email=${email}`;
            } else {
                formattedPath = `${formattedPath}?email=${email}`;
            }
        }

        history.push({
            pathname: formattedPath,
            state: path.state,
        });
    };

    const replace = (
        path: string | LocationDescriptor<any>,
        state?: any,
        hasNoCaseId?: boolean
    ) => {
        let newPath = onGetPath(typeof path === 'string' ? path : path.pathname!);

        const initialPath =
            application_id && user_id
                ? `/${application_id}/${user_id}${case_id && !hasNoCaseId ? `/${case_id}` : ''}`
                : '';

        if (typeof path === 'string') {
            let formattedPath = `${initialPath}${newPath}`;

            if (email) {
                if (formattedPath.includes('?')) {
                    formattedPath = `${formattedPath}&email=${email}`;
                } else {
                    formattedPath = `${formattedPath}?email=${email}`;
                }
            }

            history.push(formattedPath, state);

            return;
        }

        newPath = onGetPath(`${path.pathname}${path?.search ? path?.search : ''}`!);

        let formattedPath = `${initialPath}${newPath}`;

        if (email) {
            if (formattedPath.includes('?')) {
                formattedPath = `${formattedPath}&email=${email}`;
            } else {
                formattedPath = `${formattedPath}?email=${email}`;
            }
        }

        history.push({
            ...path,
            search: '',
            pathname: formattedPath,
        });
    };

    return {
        goBack,
        push,
        replace,
        listen: history.listen,
        history,
        application_id,
        user_id,
        case_id,
    };
};

export default useWebHistory;
